<template>
  <b-container fluid>
    <b-row>
      <b-col cols="10">
        <b-row>
          <b-col>
            <h3>
              <b-badge variant="primary">
                Notes
              </b-badge>
              <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
            </h3>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Household ID: </b-col>
          <b-col>{{ HHID }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Family Name: </b-col>
          <b-col>{{ FamilyName }}</b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col>Claim ID: </b-col>
          <b-col>{{ ClaimID }}</b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-button
              block
              class="mb-2 mt-2 pb-2 pt-2"
              @click="$router.go(-1)">
              Back
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              block
              :disabled="!canAddNote"
              class="mb-2 mt-2 pb-2 pt-2"
              @click="$router.push({path: `/addnote/${HHID}`})">
              Add Note
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <strong>Notes History</strong>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table 
          small responsive striped
          stacked="sm"
          class="mt-4"
          :busy="waiting"
          :items="notesTable.items" 
          :fields="notesTable.fields">
          <!-- OK TL boolean rendered as a read-only checkbox -->
          <template slot="ReceivedStatus" slot-scope="data">
            <b-form-checkbox
              v-if="!waiting"
              @change="tickReadReceived($event, data.item.NoteID)"
              :disabled="!data.item.ReadReceivedClickable"
              v-model="data.item.ReceivedStatus">
            </b-form-checkbox>
            <b-spinner
              v-else
              small
              label="Loading...">
            </b-spinner>
          </template>
          <div slot="table-busy" class="text-center text-danger">
            <b-spinner class="align-middle"></b-spinner>
            <!-- <strong>Loading...</strong> -->
          </div>
          <!-- scoped Note slot -->
          <template slot="Note" slot-scope="row">
            <div v-if="isLongNote(row.item.Note)">
              {{ row.item.Note.substring(1,255) }} ...
              <b-button
                size="sm"
                @click="row.toggleDetails">
                {{ row.detailsShowing ? 'Hide' : 'Show' }} full note
              </b-button>
            </div>
            <div v-else>
              {{ row.item.Note }}
            </div>
          </template>
          <!-- row details -->
          <template slot="row-details" slot-scope="row">
            <p v-if="!waiting">{{ row.item.Note }}</p>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      waiting: false,
      HHID: '',
      FamilyName: '',
      ClaimID: '',
      notesTable: {
        items: [],
        fields: [
          // hidden field
          {
            key: 'NoteID',
            thClass: 'd-none', 
            tdClass: 'd-none'
          },
          // hidden field
          {
            key: 'ReadReceivedClickable',
            thClass: 'd-none', 
            tdClass: 'd-none'
          },
          {
            key: 'Date',
            label: 'Date'
          },
          {
            key: 'From',
            label: 'From'
          },
          {
            key: 'Recipient',
            label: 'To'
          },
          {
            key: 'Note',
            label: 'Note'
          },
          {
            key: 'ReceivedStatus',
            label: 'Read/Received'
          },
        ]
      }
    }
  },
  created() {
    this.HHID = this.$route.params.hhid
    this.searchNotes()
  },
  // while on this page, cause changes in route params to update page with data
  // from the new hhid param
  watch: {
    '$route.params.hhid'(to, from) {
      console.log({to, from})
      this.searchNotes()
    },
  },
  computed: {
    // everyone but HQView can add notes
    canAddNote() {
      return !this.$store.getters['auth/getIsHQView']
    }
  },
  methods: {
    ...mapActions('notes', {fetchNotes: 'fetchUnreadNotes'}),
    searchNotes() {
      this.HHID = this.$route.params.hhid
      let vm = this
      this.waiting = true
      // populate page
      apiService.getHouseholdNotes(this.HHID)
      .then((response) => {
        vm.FamilyName = response.data.FamilyName
        vm.ClaimID = response.data.ClaimID
        //populate table
        if (response.data.Notes.find(obj=> obj.Date != "")){
            vm.notesTable.items = response.data.Notes}
        else{
          vm.notesTable.items = []
        }
        this.waiting = false
      })
    },
    tickReadReceived(checked, noteID) {
      this.waiting = true
      let vm = this
      apiService.setNoteRead(noteID)
      .then(() => {
        vm.searchNotes()
        vm.waiting = false
        vm.fetchNotes()
      })
      .catch(() => {
        vm.waiting = false
      })
    },
    isLongNote(note) {
        return note.length > 255
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/HouseholdNotesPage.vue